import React, { useState, useEffect, useContext, useRef } from 'react';
import { Form, Formik, Field } from 'formik';
import { useHistory } from 'react-router-dom';

import Layout from 'components/Layout';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import Button, { ButtonContainer } from 'components/Button';
import Subtitle from "components/SubTitle";
import Icon from 'components/Icon';

import { FitinsurAPI, MessageCenter } from 'utils';
import FitFormTolls from 'utils/src/fitinsur-form-tolls';
import { GlobalLoaderContext, GlobalAuthContext } from 'store/context';
import { ButtonContent, Fieldset, Heading, BackToList, Content } from './styles';

export default function ViewEnquirity({ match, location }) {
  const [statusOperation, setStatusOperation] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [riskQst, setRiskQst] = useState([]);
  const [personsQst, setPersonsQst] = useState([]);
  const [operationsQst, setOperationsQst] = useState([]);
  const [paymentsQst, setPaymentsQst] = useState([]);
  const [initialValue, setInitialValue] = useState({});

  // main execution
  const fitinsurAPI = new FitinsurAPI();
  const mc = new MessageCenter();
  const formikRef = useRef();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const fitForm = new FitFormTolls();

  const getQuote = async () => {
    let mergeQuestions;
    fitinsurAPI.setAuthToken(authContext.token);
    fitinsurAPI.requestAddAction(match.params.idProduct, null)
      .then((x) => x.json())
      .then(response => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          loading.stop();
          return;
        }
        console.log(response);
        mergeQuestions = [
          ...questions,
          ...response.ret_value.riskQuestionnaire,
          ...response.ret_value.personQuestionnaire,
          ...response.ret_value.operationQuestionnaire,
          ...response.ret_value.formPaymentQuestionnaire,
          ...response.ret_value.paymentQuestionnaire
        ];
        setQuestions(state => [...state, ...mergeQuestions]);
      })
      .catch((e) => {
        console.log(e);
        loading.stop();
      });

    fitinsurAPI
      .setAuthToken(authContext.token);
    fitinsurAPI
      .requestGetQuote(match.params.idProduct, match.params.idOperation)
      .then((x) => x.json())
      .then((response) => {
        const { ret_value } = response;

        const getUniqObjBeetweenSames = (array) =>
          array
            .map((item) => ({
              answer: item.answer,
              idQuestion: item.idQuestion,
              questionDescription: item.dsQuestion,
              questionDomain: item.idDomainQuestion
            }))
            .filter(
              (item, pos, self) =>
                self.findIndex(
                  (v) =>
                    v.answer === item.answer && item.idQuestion == v.idQuestion
                ) === pos
            );

        const operations = getUniqObjBeetweenSames(ret_value.operations);
        const persons = getUniqObjBeetweenSames(ret_value.persons);

        console.log('risks array: ', ret_value.risks);
        const risks = [...getUniqObjBeetweenSames(ret_value.risks), ...getUniqObjBeetweenSames(ret_value.riskQuestionnaires)];
        console.log('risks process: ', risks);

        console.log('payment array: ', ret_value.payments);
        const payments = getUniqObjBeetweenSames(ret_value.payments);
        console.log('payment process: ', payments);

        setRiskQst(risks);
        setPersonsQst(persons);
        setOperationsQst(operations);
        setPaymentsQst(payments);
        setStatusOperation(ret_value.operation.idDomainStatus);
      })
      .catch((e) => {
        console.log(e);
        loading.stop();
      });
  };

  const findAnswer = (findIdQuestion, array) => {
    const question = questions.find((item) => item.idQuestion == findIdQuestion);
    if (!question) {
      return;
    };

    if (question.questionDomain == 43 || question.questionDomain == 44) {
      const chosen = array.filter(({ idQuestion }) => idQuestion == findIdQuestion);

      const result = question.answerOptions.filter(
        (objFromA) => chosen.find(
          (objFromB) => objFromA.answerOptionDescription == objFromB.answer
        )
      );
      const answerOption = {
        idAnswerOption: (result && result.length > 0 ? result[0].idAnswerOption : null),
        dsAnswerOption: (result && result.length > 0 ? result[0].answerOptionDescription : null)
      };
      return answerOption;
    }

    return array.find(question => question.idQuestion == String(findIdQuestion)).answer;
  };

  const fieldsConstructor = (questionnaire) => {
    return questionnaire.map((element) => (
      !fitForm.verifyVisiblity(String(element.idQuestion), questions) &&
      <Col md={6} sm={6} lg={6} style={{ alignSelf: "flex-end" }}>
        <Field
          name={String(element.idQuestion)}
          label={fitForm.getDsQuestion(String(element.idQuestion), questions)}
          component={fitForm.verifyComponent(String(element.idQuestion), questions)}
          options={fitForm.verifyOptions(String(element.idQuestion), questions)}
          disabled
          readOnly
        />
      </Col>
    ))
  };

  useEffect(() => {
    async function getQuotationInfo() {
      await getQuote();
    }
    getQuotationInfo();
  }, []);

  useEffect(() => {
    // Transform questionnaire array in object with key idQuestion and answer
    const getObject = (arr) => {
      let obj = {};
      arr.forEach((element) => {
        obj[`${element.idQuestion}`] = findAnswer(element.idQuestion, arr)
      });
      return obj;
    }

    //Process questionnaires
    const risksObj = getObject(riskQst);
    const operationsObj = getObject(operationsQst);
    const personsObj = getObject(personsQst);
    const paymentsObj = getObject(paymentsQst);
    // Defining initial values with the answers of all questionnaires to display the form 
    setInitialValue({ ...risksObj, ...operationsObj, ...personsObj, ...paymentsObj });

  }, [questions]);

  return (
    <Layout
      title="Cotação"
      subtitle={location.state.productName}
    >
      <Subtitle
        idProduct={match.params?.idProduct}
        idOperation={match?.params?.idOperation}
        statusOperation={statusOperation}
        stage={1}
      />
      <Formik
        innerRef={formikRef}
        initialValues={initialValue}
        onSubmit={() => { }}
        enableReinitialize={true}
      >
        {({ values }) => (
          <Form>
            <Content>
              {personsQst.length > 0 &&
                <Fieldset>
                  <Heading>Questionario de Pessoa</Heading>
                  <Row>
                    {fieldsConstructor(personsQst)}
                  </Row>
                </Fieldset>
              }
              {riskQst.length > 0 &&
                <Fieldset>
                  <Heading>Questionario de Risco</Heading>
                  <Row>
                    {fieldsConstructor(riskQst)}
                  </Row>
                </Fieldset>
              }

              {operationsQst.length > 0 &&
                <Fieldset>
                  <Heading>Questionario de Operação</Heading>
                  <Row>
                    {fieldsConstructor(operationsQst)}
                  </Row>
                </Fieldset>
              }

              {paymentsQst.length > 0 &&
                <Fieldset>
                  <Heading>Questionario de Pagamento</Heading>
                  <Row>
                    {fieldsConstructor(paymentsQst)}
                  </Row>
                </Fieldset>
              }
            </Content>
            <ButtonContainer>
              <BackToList onClick={() => history.push("/quotes")}>
                <Icon name="vector" />
                <Heading style={{ fontSize: 16 }}>VOLTAR PARA LISTA</Heading>
              </BackToList>
            </ButtonContainer>
          </Form>
        )}
      </Formik>
    </Layout >
  )
}